import API from 'services/api';

import { IICal } from '../models';

export const getICalUnit = ({ unitId }: { unitId: string }): Promise<IICal> =>
  API.get(`/api/accommodation/iCal/units/${unitId}`)?.then(response => response?.data);
